export default "__VITE_ASSET__5e685b08__"